import { Layout } from 'antd';
import { logo } from 'assets/images';
import { Header, Sider } from 'components';
import { Profile } from 'components/Profile';
import { Subscription } from 'components/Subscription';
import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import './index.scss';
import { MachineVnc } from 'components/MachineVnc';
import { EMBanner } from 'components/EMBanner';
import { generateSites } from './site';
import { routePaths } from './route-paths';
import { privateRoutes, publicRoutes } from './routes';

const AntdHeader = Layout.Header;

const Routes = ({ isLoggedIn }) => {
  const { t } = useTranslation();
  const sites = useMemo(() => generateSites(t), [t]);
  const [showProfile, setShowProfile] = useState(false);

  const closeShowProfile = useCallback(() => {
    setShowProfile(false);
  }, []);

  return (
    <Layout className="layout">
      <BrowserRouter>
        {isLoggedIn ? (
          <Layout>
            <AntdHeader>
              <EMBanner />
            </AntdHeader>
            <Layout>
              <Sider sites={sites} brand={logo} />
              <Layout>
                <Header setShowProfile={setShowProfile} />
                <Layout className="layout-content">
                  <Switch>
                    {privateRoutes.map((privateRoute) => {
                      return (
                        <Route
                          path={privateRoute.path}
                          key={privateRoute.path}
                          component={privateRoute.component}
                          {...privateRoute}
                        />
                      );
                    })}
                    <Redirect exact from="*" to={routePaths.overview} />
                  </Switch>

                  <Profile
                    showProfile={showProfile}
                    closeShowProfile={closeShowProfile}
                  />

                  {process.env.REACT_APP_FEATURE_VNC_SESSION_ENABLED ===
                    'true' && <MachineVnc />}

                  <Subscription />
                </Layout>
              </Layout>
            </Layout>
          </Layout>
        ) : (
          <Switch>
            {publicRoutes.map((publicRoute) => {
              return (
                <Route
                  path={publicRoute.path}
                  key={publicRoute.path}
                  component={publicRoute.component}
                  {...publicRoute}
                />
              );
            })}
            <Redirect exact from="*" to={routePaths.emRedirectPage} />
          </Switch>
        )}
      </BrowserRouter>
    </Layout>
  );
};

Routes.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired
};

export default Routes;
